export default {
  userSignUp: 'USER_SIGNUP',
  userSignUpSuccess: 'USER_SIGNUP_SUCCESS',
  userSignUpFailed: 'USER_SIGNUP_FAILED',
  setCurrentUser: 'SET_CURRENT_USER',
  resetToInitialState: 'SIGN_UP_RESET_TO_INITIAL_STATE'
};
